<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="success"
          title="Qualificações"
          text="Qualificações aguardando qualificação manual"
        >
          <v-container>
            <v-layout>
              <v-flex xs12 md9 class="text-lg-left">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-progress-linear
            v-if="loading"
            height="2"
            color="cyan"
            indeterminate
          ></v-progress-linear>
          <span v-if="loading">Isso pode demorar um pouco...</span>
          <v-data-table
            dense
            :headers="headers"
            :items="qualificationsUnresolved"
            v-else
            :loading="loading"
            rows-per-page-text="Linhas por página"
            no-data-text="Não há qualificações aguardando qualificação manual"
            :search="search"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.created_at | formatarData }}</td>
              <td>{{ props.item.consumer_unit }}</td>
              <td>{{ props.item.cpf }}</td>
              <!-- <td>{{ props.item.origin }}</td> -->
              <td>
                <v-progress-circular
                  v-if="props.item.status === 'pending'"
                  color="grey"
                  size="24"
                  indeterminate
                ></v-progress-circular>
                <v-icon v-else :color="formatStatusColor(props.item.status)">{{
                  props.item.status | formatStatusIcon
                }}</v-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon color="transparent" v-on="on">help</v-icon>
                  </template>
                  <span>{{ props.item.status | formatStatusText }}</span>
                </v-tooltip>
              </td>
              <td>
                <!-- <v-btn
                  small
                  outline
                  class="ma-0 pa-0"
                  color="primary"
                  :disabled="loading || props.item.status === 'pending'"
                  @click.prevent="rerunQualification(props.item)"
                  >Auto
                  <v-icon right dark>sync</v-icon>
                </v-btn> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      outline
                      class="ml-2 ma-0 pa-0"
                      color="tertiary"
                      :disabled="
                        loading ||
                        !props.item.user_detail.id ||
                        props.item.status === 'pending'
                      "
                      @click.prevent="
                        customerSelected(props.item.user_detail.id)
                      "
                      >Manual
                      <v-icon right dark>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Copie o número da UC antes de prosseguir.</span>
                </v-tooltip>
              </td>
              <!-- <td>{{ props.item.user_detail.status }}</td> -->
              <!-- <td>{{ props.item.consumer_unit_exists}}</td> -->
              <!-- <td>{{ props.item.user_detail.installation_numbers | formatUCs }}</td> -->
              <td>
                {{
                  props.item.user_detail.signedcontract_at
                    | formatSignedContractDate
                }}
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{
                      props.item.user_detail.signedcontract_by
                    }}</span>
                  </template>
                  <span>{{
                    props.item.user_detail.signedcontract_partner
                  }}</span>
                </v-tooltip>
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua busca para "{{ search }}" Não encontrou resultados.
              </v-alert>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.value"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.top"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn color="white" flat @click="snackbar.value = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { eventBus } from "../main";
import { reprocessQualification } from "../services/qualification";
export default {
  data() {
    return {
      search: "",
      qualifications: [],
      headers: [
        {
          text: "Criado em",
          value: "created_at",
          align: "left",
          sortable: true,
        },
        { text: "Unidade Consumidora", value: "consumer_unit", align: "left" },
        { text: "CPF", value: "cpf", align: "left" },
        // { text: "Origem", value: "origin" },
        { text: "Status", value: "solved" },
        { text: "Qualificar", value: "" },
        // { text: "User Status", value: "user_detail.status" },
        // { text: "UCs", value: "user_detail.installation_numbers" },
        { text: "Assinado em", value: "user_detail.signedcontract_at" },
        { text: "Assinado por", value: "user_detail.signedcontract_by" },
      ],
      pagination: {
        rowsPerPage: 10, // -1 for All",
        descending: true,
      },
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
    };
  },
  mounted() {
    this.getQualifications();
  },
  computed: {
    ...mapGetters("qualification", ["qualificationsUnresolved", "loading"]),
  },
  methods: {
    ...mapActions("qualification", [
      "resetState",
      "getQualificationsUnresolved",
    ]),
    getQualifications() {
      this.getQualificationsUnresolved();
    },
    customerSelected(customer_id) {
      eventBus.$emit("userSelected", customer_id);
      this.$router.push({
        path: "/membro/" + customer_id,
        params: { id: customer_id },
      });
    },
    async rerunQualification(qualification) {
      await reprocessQualification(qualification.id)
        .then((ret) => {
          if (ret.status === 200) {
            this.showSnackBar(
              "Qualificação reprocessando...",
              "bottom",
              "green",
            );
          } else {
            console.error("ret", ret);
            console.error(ret.data);
            this.showSnackBar(
              "Erro ao reprocessar qualificação.",
              "bottom",
              "warning",
            );
          }
        })
        .catch((err) => {
          console.error("err", err);
          let message = err.response
            ? err.response.data
              ? err.response.data.error
              : err.message
            : err.message;
          console.error(message);
          this.showSnackBar(
            "Erro ao reprocessar qualificação. " + message,
            "bottom",
            "warning",
          );
        });
    },
    formatStatusColor: function (value) {
      if (value === "bill_not_found") return "orange";
      else if (value === "error") return "red";
      else return "grey";
    },
    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      if (value._seconds) {
        let timestamp = value; // firebase data
        let myDate = new Date(timestamp._seconds * 1000); // date object
        return moment(myDate).format("DD/MM/YYYY HH:mm");
      } else if (value.seconds) {
        let timestamp = value; // firebase data
        let myDate = new Date(timestamp.seconds * 1000); // date object
        return moment(myDate).format("DD/MM/YYYY HH:mm");
      } else {
        let myDate = value.toDate();
        return moment(myDate).format("DD/MM/YYYY HH:mm");
      }
      // if (typeof(myDate) !== "object") return ""
    },
    formatStatusIcon: function (value) {
      if (value === "bill_not_found") return "mdi-file";
      else if (value === "error") return "error";
      else return "done_all";
    },
    formatStatusText: function (value) {
      if (value === "bill_not_found")
        return "Conta não encontrada ao qualificar.";
      else if (value === "error") return "Erro ao qualificar.";
      else if (value === "pending") return "Qualificando...";
      else return value;
    },
    formatUCs: function (value) {
      console.log("value", value);
      if (value && value.length > 0) {
        return value.map((item) => {
          if (item.text) {
            console.log(item.text);
            return item.text;
          } else {
            console.log(item);
            return item;
          }
        });
      } else {
        return "?";
      }
    },
    formatSignedContractDate: function (value) {
      console.log(value);
      if (value) {
        try {
          return moment(value.toDate()).format("DD/MM/YYYY");
        } catch (_) {
          return moment(new Date(value)).format("DD/MM/YYYY");
        }
      }
    },
  },
};
</script>
<style scoped></style>
